const REGISTRATION_DATES = {
  earlyRegistrationStart: new Date("2026-09-01T00:00:00"), 
  normalRegistrationStart: new Date("2026-09-05T00:00:00"), 
  waitlistStart: new Date("2026-09-07T00:00:00"), 
  eventDate: new Date("2026-11-20T17:30:00"), 
};

export default REGISTRATION_DATES;